module.exports = __webpack_public_path__ + "img/Slice12-min.4edcfc06.png";